import Vue from "vue";
import VueRouter from "vue-router";

import Store from "@/store";
import API from "@/services/api";

import Login from "@/views/Login.vue";
import Forgot from "@/views/Forgot.vue";
import Reset from "@/views/Reset.vue";
import ParticipantInfo from "@/views/ParticipantInfo.vue";
import Calculator from "@/views/Calculator.vue";
import CalculatorResult from "@/views/CalculatorResult.vue";
import CustomIndicator from "@/views/CustomIndicator.vue";
import ReleaseComplete from "@/views/ReleaseComplete.vue";
import Participants from "@/views/Participants.vue";
import EditParticipant from "@/views/EditParticipant.vue";
import ChangeLocation from "@/views/ChangeLocation.vue";
import UnreturnedSkis from "@/views/UnreturnedSkis.vue";
import Reports from "@/views/Reports.vue";
import Privacy from "@/views/Privacy.vue";
import Terms from "@/views/Terms.vue";

Vue.use(VueRouter);

const routes = [
  {
    path: "/",
    redirect: "/info",
  },

  // Auth routes
  {
    path: "/login",
    name: "Login",
    component: Login,
  },
  {
    path: "/forgot",
    name: "Forgot",
    component: Forgot,
  },
  {
    path: "/reset",
    name: "Reset",
    component: Reset,
  },

  // Pre-register flow
  {
    path: "/info",
    name: "ParticipantInfo",
    component: ParticipantInfo,
  },
  {
    path: "/calculator",
    name: "Calculator",
    component: Calculator,
    meta: {
      requireInfo: true,
    },
  },
  {
    path: "/result",
    name: "CalculatorResult",
    component: CalculatorResult,
    meta: {
      requireInfo: true,
      requireIndicator: true,
    },
  },
  {
    path: "/custom",
    name: "CustomIndicator",
    component: CustomIndicator,
    meta: {
      requireInfo: true,
      requireIndicator: true,
    },
  },
  {
    path: "/complete",
    name: "Complete",
    component: ReleaseComplete,
  },

  // Stockli rep routes
  {
    path: "/participants",
    name: "Participants",
    component: Participants,
    meta: {
      authed: true,
    },
  },
  {
    path: "/participants/:id",
    name: "EditParticipant",
    component: EditParticipant,
    meta: {
      authed: true,
    },
  },
  {
    path: "/location",
    name: "ChangeLocation",
    component: ChangeLocation,
    meta: {
      authed: true,
    },
  },
  {
    path: "/unreturned",
    name: "UnreturnedSkis",
    component: UnreturnedSkis,
    meta: {
      authed: true,
    },
  },
  {
    path: "/privacy",
    name: "Privacy",
    component: Privacy,
  },
  {
    path: "/terms",
    name: "Terms",
    component: Terms,
  },

  // Admin routes
  {
    path: "/reports",
    name: "Reports",
    component: Reports,
    meta: {
      authed: true,
    },
  },

  // Catch anything else
  {
    path: "*",
    redirect: "/",
  },
];

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior(to, from, savedPosition) {
    // If we are navigating back/forth, go to wherever they were last scrolled. Otherwise, scroll to top.
    if (savedPosition) {
      return savedPosition;
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach((to, from, next) => {
  if (!API.IsLoggedIn() && Store.state.email) {
    Store.dispatch("Logout");
  }
  const destination = RouteGuards(to);
  next(destination);
});

// Break out into a function so we can return for simplicity
function RouteGuards(to) {
  if (to.meta && to.meta.authed) {
    // Route requires auth
    if (!API.IsLoggedIn()) {
      // If no auth, direct to login
      return { path: "/login" };
    }
  }

  if (to.meta && to.meta.requireInfo) {
    if (!Store.state.skierInfo || !Store.state.skierInfo.Email) {
      return { path: "/info" };
    }
  }

  if (to.meta && to.meta.requireIndicator) {
    if (!Store.state.skierInfo || !Store.state.skierInfo.Indicator_Setting) {
      return { path: "/calculator" };
    }
  }

  // No guard problems, allow route
  return;
}

export default router;
